$(document).ready(function() {
	var productsValidation = {
		$step1: $('#stepSelectProduct'),
		$step2: $('#stepResult'),
		init: function() {
			// step1
			this.$product = this.$step1.find('#products');
			this.$model = this.$step1.find('#model');
			this.$suffix = this.$step1.find('#suffix');
			this.$searchForm = this.$step1.find('#searchForm');

			this.eventInit();
		},
		selectHandler: function(e) {
			var self = this,
				$target = $(e.target),
				param = $target.serialize(),
				ajaxUrl = $target.data('url');
			// 20200609 START 전호근 - 디자인 수정
			if ($target.checkValidation()) {
				ajax.noCacheCall(ajaxUrl, param, 'json', function(data) {
					if (data && Object.keys(data).length !== 0) {
						var $guideArea = self.$step1.find('.model-image-box');

						self.$model.removeAttr('disabled').prop('disabled', false);
						self.$suffix.removeAttr('disabled').prop('disabled', false);

						self.$model.attr('placeholder', data.model).val('');
						self.$suffix.attr('placeholder', data.suffix).val('');

						$guideArea.find('.default-info').hide();
						$guideArea.find('.product-info').show();
						$guideArea.find('.product-info .location').text(data.location);
						$guideArea.find('.image-box img').attr({
							'src': data.src,
							'alt': data.alt
						});
						bindImgError();
					}
				}, 'post', 'body');
			}
			// 20200609 END 전호근 - 디자인 수정
		},
		searchHandler: function(e) {
			var self = this,
				$target = $(e.target),
				method = $target.attr('method'),
				ajaxUrl = $target.data('action'), //LGEAF-34
				product,model,suffix,
				param = null;

			product = self.$product.val();
			model = self.$model.val().toUpperCase();
			suffix = self.$suffix.val().toUpperCase();
			self.$model.val(model);
			self.$suffix.val(suffix); 
			
			param = $target.serialize();

			if ($target.checkValidation()) {
				ajax.noCacheCall(ajaxUrl, param, 'json', function(data) {
					if (data && Object.keys(data).length !== 0) {
						self.$step2.addClass('active');

						self.$step2.find('.product').text(product);
						//LGEAE-576
						if(model != null && model != ''){
							self.$step2.find('.model').text(model + '.' + suffix);
						} else{
							self.$step2.find('.model').text(suffix);
						}
						self.$step2.find('.message').hide();

						if (data.flag) {
							//LGEAF-34 start
							self.$step2.find('.model').show();
							//LGEAE-576
							if(model != null && model != ''){
								self.$step2.find('.model').text(model + '.' + suffix);
							} else{
								self.$step2.find('.model').text(suffix);
							}
							$('.message-wrap').find('.model').prepend('"');
							$('.message-wrap').find('.model').append('"');
							//LGEAF-34 end
							
							if (data.classification === 'warranty') {
								self.$step2.find('.message.warranty').show();
							} else {
								self.$step2.find('.message.others').show();
							}
						} else {
							//LGEAF-34, PJTROLLOUT21-7 start
							if (COUNTRY_CODE == 'africa' || COUNTRY_CODE == 'africa_fr') {
								self.$step2.find('.model').hide();
							} else {
								self.$step2.find('.model').show();
								//LGEAE-576
								if(model != null && model != ''){
									self.$step2.find('.model').text(model + '.' + suffix);
								} else{
									self.$step2.find('.model').text(suffix);
								}
								$('.message-wrap').find('.model').prepend('"');
								$('.message-wrap').find('.model').append('"');
							}
							//LGEAF-34, PJTROLLOUT21-7 end
							self.$step2.find('.message.unknown').show();
						}

						// 200608 START 전호근 - 검색 완료 시 스크롤 이동
						$('html, body').stop().animate({
							scrollTop: self.$step2.offset().top
						}, 500);
						// 200608 END 전호근 - 검색 완료 시 스크롤 이동
					}
				}, method, 'body');
			}

			e.preventDefault();
		},
		eventInit: function() {
			var self = this;

			self.$product.on('change', $.proxy(self.selectHandler, self));
			self.$searchForm.on('submit', $.proxy(self.searchHandler, self));
		}
	};
	productsValidation.init();
});


